import React from "react";
import { BaseButton } from "./BaseButton";

export function GreyedButton(props) {
	return (
		<BaseButton {...props} color="grey">
			{props.children}
		</BaseButton>
	);
}
